import { formatAmountForDisplay, formatDate, toCents } from 'src/utils'
import * as types from './types'

function convertAmount(amount) {
  return amount ? toCents(amount) : null
}

export default {
  [types.PAYABLES_TO_SHOW](state) {
    return state.payables.map((payable) => {
      return {
        id: payable.id,
        clientCountry: payable.client_country,
        clientName: payable.client_name ?? '-',
        partnerName: payable.partner_name,
        amount: payable.amount,
        formattedAmount: formatAmountForDisplay(
          payable.amount,
          payable.currency
        ),
        instalmentsNumber: payable.instalments_number,
        repaymentCycle: payable.repayment_cycle,
        createdAt: payable.created_at,
        formattedCreatedAt: formatDate(payable.created_at, 'DD/MM/YYYY'),
        state: payable.state,
        currency: payable.currency,
        clientId: payable.client_id,
        clientCrn: payable.client_crn,
        partnerId: payable.partner_id
      }
    })
  },
  [types.PARAMS_TO_SEND](state) {
    return {
      // pagination
      limit: state.pagination.limit,
      offset: state.pagination.offset,
      descending: state.pagination.sortDesc[0],
      sortBy: state.pagination.sortBy[0],
      // filters
      ...state.filters,
      amountFrom: convertAmount(state.filters.amountFrom),
      amountTo: convertAmount(state.filters.amountTo)
    }
  }
}
